import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  cardPaper: {
    padding: theme.spacing(6),
  },
  barText: {
    position: "relative",
    top: -23.5,
    left: 8,
    fontWeight: "bold",
    fontSize: 13,
    color: "#FFF",
  },
}));

export default useStyles;
